// extracted by mini-css-extract-plugin
export var dividerLine = "_a3-3";
export var itemImage = "_a3-9";
export var lightDivider = "_a3-4";
export var modalContent = "_a3-5";
export var modalContentCompact = "_a3-6";
export var productCard = "_a3-a";
export var productImage = "_a3-b";
export var productImageCompact = "_a3-7";
export var productImagePlaceholder = "_a3-c";
export var productImagePlaceholderCompact = "_a3-8";
export var progressBarBackground = "_a3-1";
export var progressBarContainer = "_a3-0";
export var progressBarFill = "_a3-2";